export const MEDICAL_HISTORY_QUESTIONNAIRE_NAME =
  'ChoremeioAtomicMedicalHistory';
export const EXAMINATION_QUESTIONNAIRE_NAME = 'ChoremeioExamination';
export const PERINATAL_PERIOD_QUESTIONNAIRE_NAME = 'ChoremeioPerinatalPeriod';
export const PRENATAL_PERIOD_QUESTIONNAIRE_NAME = 'ChoremeioPrenatalPeriod';
